import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {AgentNumberApi} from 'Users/api/api';
import axiosInstance from 'Shared/utilities/axiosInstance';

const agentNumberApi = new AgentNumberApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  getAgentNumbersByTaxIdentifier: (identifier: string, encryptedIdentifier?: string) => {
    return withCancellation(cancelToken =>
      (encryptedIdentifier
        ? agentNumberApi.agentNumberGetByEncryptedIdentifier('1', encryptedIdentifier, {
            ...getAxiosConfig(cancelToken, false),
          })
        : agentNumberApi.agentNumberGetByIdentifier(identifier, '1', getAxiosConfig(cancelToken, false))
      ).then(handleResponse)
    );
  },
};
